"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AInterleavedConnector = void 0;
/**
 * @public
 * {@inheritDoc IInterleavedConnector}
 */
class AInterleavedConnector {
    constructor(config, initialDataLength, bytesPerElement) {
        this.offsets = config.offsets;
        this.blockElementCount = config.blockElementCount;
        this.startIndex = this.getInitialStartIndex(config);
        this.length = this.getInitialLength(config, initialDataLength, this.startIndex);
        this.blockByteSize = bytesPerElement * this.blockElementCount;
    }
    static getDescriptor(config, storageType) {
        var _a;
        return {
            offsets: config.offsets,
            byteOffset: ((_a = config.startIndex) !== null && _a !== void 0 ? _a : 0) * config.blockElementCount * storageType.BYTES_PER_ELEMENT,
            blockElementCount: config.blockElementCount,
            blockByteSize: config.blockElementCount * storageType.BYTES_PER_ELEMENT,
        };
    }
    getDescriptor() {
        return {
            offsets: this.offsets,
            byteOffset: this.getStart() * this.getBlockByteSize(),
            blockElementCount: this.getBlockElementCount(),
            blockByteSize: this.getBlockByteSize(),
        };
    }
    getValue(index, offset) {
        return this.getData()[index * this.blockElementCount + offset];
    }
    setValue(index, offset, value) {
        this.getData()[index * this.blockElementCount + offset] = value;
    }
    getStart() {
        return this.startIndex;
    }
    setStart(index) {
        this.startIndex = index;
    }
    getLength() {
        return this.length;
    }
    setLength(length) {
        this.length = length;
    }
    getMaximumLength() {
        return this.getData().length / this.blockElementCount;
    }
    getBlockElementCount() {
        return this.blockElementCount;
    }
    getBlockByteSize() {
        return this.blockByteSize;
    }
    getInterleavedBuffer() {
        return this.getData();
    }
    getEnd() {
        return this.getStart() + this.getLength();
    }
    getLoggableValue() {
        const buffer = this.getData();
        const getBlockElementCount = this.getBlockElementCount();
        const result = new Array(buffer.length / getBlockElementCount);
        for (let i = 0, iEnd = result.length; i < iEnd; ++i) {
            const block = result[i] = new Array(getBlockElementCount);
            for (let j = 0; j < getBlockElementCount; ++j) {
                block[j] = buffer[i * getBlockElementCount + j];
            }
        }
        return result;
    }
    getInitialStartIndex(config) {
        return config.startIndex == null
            ? 0
            : config.startIndex;
    }
    getInitialLength(config, initialDataLength, start) {
        return config.length == null
            ? ((initialDataLength - start * this.blockElementCount) / this.blockElementCount) | 0
            : config.length;
    }
}
exports.AInterleavedConnector = AInterleavedConnector;
//# sourceMappingURL=a-interleaved-connector.js.map